module.exports = __webpack_public_path__ + "static/media/lendings.b0e21f08.svg";